import { render, staticRenderFns } from "./ItsSalesVehicle.vue?vue&type=template&id=1544fb47&scoped=true&"
import script from "./ItsSalesVehicle.vue?vue&type=script&lang=js&"
export * from "./ItsSalesVehicle.vue?vue&type=script&lang=js&"
import style0 from "./ItsSalesVehicle.vue?vue&type=style&index=0&id=1544fb47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1544fb47",
  null
  
)

export default component.exports